// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-cards[data-v-27fe7bb8] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(314px, 1fr));\n  grid-auto-rows: 163px;\n}\n.role-cards[data-v-27fe7bb8]  {\n  padding-left: 0;\n  padding-right: 0;\n}", ""]);
// Exports
module.exports = exports;
